import { render } from "./salaryServices.vue?vue&type=template&id=afcbc9ce&scoped=true"
import script from "./salaryServices.vue?vue&type=script&lang=js"
export * from "./salaryServices.vue?vue&type=script&lang=js"

import "./salaryServices.vue?vue&type=style&index=0&id=afcbc9ce&lang=scss&scoped=true"
import "./salaryServices.vue?vue&type=style&index=1&id=afcbc9ce&lang=scss&scoped=true"
import "./salaryServices.vue?vue&type=style&index=2&id=afcbc9ce&lang=css"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afcbc9ce"]])

export default __exports__